import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,

    title: getDefaultValue(
      searchParams.get('title'),
      'Присылайте фамилию\\n или номер игрока',
    ),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),

    startFrom: parseInt(searchParams.get('startFrom') || '') || 2,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 50000,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 500,
    speedFast: searchParams.get('speedFast')
      ? parseInt(searchParams.get('speedFast') || '')
      : 100,
    titleFontSize: searchParams.get('titleFontSize') || '5.9',
    sizeQR: searchParams.get('sizeQR') || '40',
    authorFontSize: searchParams.get('authorFontSize') || '5.7',

    carousel: searchParams.get('carousel') || '1',

    // duration: searchParams.get('duration')
    //   ? parseInt(searchParams.get('duration') || '')
    //   : 500,
    // socials: searchParams.get('socials'),
    // phoneNumber,
    // carousel: searchParams.get('carousel') || '1',
    // phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || 20,
    // msgFontSize: searchParams.get('msgFontSize') || 30,
    // opacityBg: searchParams.get('opacityBg') || 0.7,
    // qrTitle1: searchParams.get('qrTitle1'),
    // qrTitle2: searchParams.get('qrTitle2'),
    // paddingQR: searchParams.get('paddingQR') || '0',
    // amount: searchParams.get('amount') || null,
    // randomOrder: searchParams.get('randomOrder') || '0',
  };
};
